var _BaseHttpGateway_instances, _BaseHttpGateway_configureInterceptors;
import { __classPrivateFieldGet } from "tslib";
import axios from 'axios';
import { BaseGateway } from './BaseGateway';
import { container } from 'tsyringe';
import { MicrofrontendManager } from '../managers/MicrofrontendManager';
import { RecognitionManager } from '../managers/RecognitionManager';
export class BaseHttpGateway extends BaseGateway {
    constructor() {
        super();
        _BaseHttpGateway_instances.add(this);
        this.axios = axios.create({
            baseURL: this.getEndpoint(),
        });
        __classPrivateFieldGet(this, _BaseHttpGateway_instances, "m", _BaseHttpGateway_configureInterceptors).call(this);
    }
}
_BaseHttpGateway_instances = new WeakSet(), _BaseHttpGateway_configureInterceptors = function _BaseHttpGateway_configureInterceptors() {
    this.axios.interceptors.request.use((config) => {
        const bearerToken = this.getBearerToken();
        if (bearerToken) {
            config.headers['authorization'] = `Bearer ${bearerToken}`;
        }
        const headers = this.getHeaders();
        if (!headers) {
            return config;
        }
        Object.keys(headers).forEach((headerKey) => {
            config.headers[headerKey] = headers[headerKey];
        });
        return config;
    });
    this.axios.interceptors.response.use((response) => response, (error) => {
        var _a;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            const recognitionManager = container.resolve(RecognitionManager);
            if (recognitionManager.getAccessToken()) {
                recognitionManager.clearCredentials();
                const config = container.resolve(MicrofrontendManager).config;
                if (config.recognition.forceRedirectToSignIn) {
                    window.location.href = config.recognition.signInUrl;
                }
            }
        }
        return Promise.reject(error);
    });
};
